/** Yearly admission dates arrive as "MM-DD" (no year: they repeat every year). Same helpers as the consult app. */

const DAYS_IN_MONTH = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

export const MONTHS = {
    en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    ar: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],
};

/** Days in a month (1-12); February allows the 29th. 31 when no month is chosen yet. */
export const daysInMonth = (month: number | null) => (month ? DAYS_IN_MONTH[month - 1] : 31);

export function parseDayMonth(value: string | null | undefined): { month: number; day: number } | null {
    const match = /^(\d{2})-(\d{2})$/.exec(value ?? '');
    if (!match) return null;
    return { month: Number(match[1]), day: Number(match[2]) };
}

export const toDayMonth = (month: number, day: number) =>
    `${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

/** "15 May" / "15 مايو". */
export function formatDayMonth(value: string | null | undefined, language: 'en' | 'ar'): string | null {
    const parsed = parseDayMonth(value);
    return parsed ? `${parsed.day} ${MONTHS[language][parsed.month - 1]}` : null;
}

/** Days from today until the next time this day/month comes round (0 = today). */
export function daysUntilNext(value: string | null | undefined, today = new Date()): number | null {
    const parsed = parseDayMonth(value);
    if (!parsed) return null;
    const start = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    let year = start.getFullYear();
    // Feb 29 only exists in leap years; use Feb 28 otherwise.
    const dateIn = (y: number) => {
        const isLeap = (y % 4 === 0 && y % 100 !== 0) || y % 400 === 0;
        const day = parsed.month === 2 && parsed.day === 29 && !isLeap ? 28 : parsed.day;
        return new Date(y, parsed.month - 1, day);
    };
    let next = dateIn(year);
    if (next < start) next = dateIn(++year);
    return Math.round((next.getTime() - start.getTime()) / 86_400_000);
}
